export const customEn = {
  StepsTitle: 'Find BBW Date Today!'
};
export const customEs = {
    StepsTitle: '¡Encuentra una cita BBW hoy!'
};
export const customDa = {
    StepsTitle: 'Find en BBW-date i dag!'
};
export const customDe = {
    StepsTitle: 'Finde ein BBW-Date heute!'
};
export const customFi = {
    StepsTitle: 'Löydä BBW-treffit tänään!'
};
export const customSv = {
    StepsTitle: 'Hitta en BBW-dejt idag!'
};
export const customFr = {
    StepsTitle: 'Trouvez un rendez-vous BBW dès aujourd’hui!'
};
export const customHu = {
    StepsTitle: 'Találj BBW randit még ma!'
};



// WEBPACK FOOTER //
// ./src/constants/custom.localization.js